module.exports = __webpack_public_path__ + "components/page-header/static/icon-search-165c29e49c6d54244d6e07d1ce93c8b4.svg";